<template>
  <div
    class="flex flex-col items-center p-40 my-40 border rounded border-grey-300"
  >
    <div
      class="flex items-center justify-center rounded-full h-125 w-125 bg-red-100"
    >
      <Icon
        iconClass="fas fa-exclamation-triangle text-red-500"
        :style="{ fontSize: '60px' }"
      />
    </div>
    <h6 class="text-center pt-20">
      {{ errorTitle }}
    </h6>
    <p class="mt-20 text-center">
      {{ errorBody }}
    </p>
    <HMButton rounded="full" class="mt-20 w-full" @click="cancel()">
      {{ cancelText }}
    </HMButton>
  </div>
</template>
<script>
export default {
  props: {
    cancelText: {
      type: String,
      required: true,
    },
    errorTitle: {
      type: String,
      required: true,
    },
    errorBody: {
      type: String,
      required: true,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
